var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',{staticClass:"float-md-left d-block d-md-inline-block mt-25"},[_c('b-link',{staticClass:"ml-25",attrs:{"href":"https://brmja.com","target":"_blank"}},[_vm._v(_vm._s(_vm.lang("brmja")))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }